const zh = {
  // Nav
  nav_home: '首页',
  nav_products: '产品中心',
  nav_about: '关于我们',
  nav_contact: '联系我们',
  nav_explore: '探索产品',

  // Hero
  hero_badge: '专注猫抓板 · 专业品质',
  hero_title1: '与猫共生',
  hero_title2: '每一次磨爪',
  hero_title3: '都是愉悦的仪式',
  hero_desc: '精选天然材料，融合人体工学设计，让猫咪爱上抓板，让家居更加美好。Koorpet，守护每一个爪印背后的幸福。',
  hero_btn_products: '探索产品系列',
  hero_btn_about: '了解品牌故事',
  hero_stat1_num: '6+',
  hero_stat1_label: '年行业深耕',
  hero_stat2_num: '50+',
  hero_stat2_label: '款产品系列',
  hero_stat3_num: '10万+',
  hero_stat3_label: '只猫咪的选择',
  hero_scroll: '向下滚动',

  // Featured Products
  featured_label: '精选产品',
  featured_title: '明星产品',
  featured_subtitle: '猫咪最爱的系列',
  featured_view_all: '查看全部产品',
  featured_empty: '暂无精选产品',

  // Features Section
  features_badge: '核心优势',
  features_title: '为什么选择 Koorpet',
  features_desc: '每一款产品都经过严格的研发测试，只为给猫咪提供最好的抓挠体验',
  feature1_title: '三层高密度压制',
  feature1_desc: '采用优质瓦楞纸三层热压工艺，密度是普通产品的2倍，耐抓耐磨，使用寿命更长。',
  feature2_title: '天然猫薄荷注入',
  feature2_desc: '精选有机猫薄荷均匀注入纸板层间，持久散发天然香气，让猫咪主动靠近使用。',
  feature3_title: '无毒环保认证',
  feature3_desc: '所有原材料通过国家环保检测，无甲醛、无重金属，猫咪啃咬也安全放心。',
  feature4_title: '人体工学设计',
  feature4_desc: '根据猫咪抓挠行为学研究，优化产品角度与高度，完美契合猫咪自然抓挠姿势。',

  // Brand Section
  brand_label: '匠心专注',
  brand_title1: '匠心专注',
  brand_title2: '只为一块好猫抓板',
  brand_desc: 'Koorpet 成立于2024年，是国内专注猫抓板研发与生产的领先品牌。工厂占地4000平方米，配备全自动化生产线，年产能达200万件。我们深信，一块好的猫抓板不仅能保护家具，更能提升猫咪的生活品质。从原材料筛选到成品出厂，每一道工序都经过严格把控。',
  brand_years_num: '2024',
  brand_years_label: '年创立',
  brand_years_desc: '4000平方米现代化工厂，全自动化生产线，持续为全球猫咪家庭提供高品质猫抓板产品。',
  brand_cert1_label: '国家质量认证',
  brand_cert1_sub: '通过 ISO 9001',
  brand_cert2_label: '天然环保材料',
  brand_cert2_sub: '无毒无害认证',
  brand_cert3_label: '出口 10+ 国家',
  brand_cert3_sub: '国际品质标准',
  brand_cert4_label: '10万+ 猫咪',
  brand_cert4_sub: '信赖之选',
  brand_cta: '',

  // CTA Section
  cta_quote_label: '铲屎官的心声',
  cta_quote: '"自从用了 Koorpet，我家沙发终于保住了！"',
  cta_label: '立即行动',
  cta_title1: '让猫咪爱上',
  cta_title2: '属于它的专属领地',
  cta_desc: '超过 10 万只猫咪已经选择了 Koorpet。天然材料、精心设计、严格品控，每一款产品都是对猫咪最好的礼物。现在下单，享受品质生活。',
  cta_btn: '立即选购',

  // Reviews Section
  reviews_title: '真实铲屎官心声：',
  reviews_subtitle: '来自全国各地猫咪主人的真实评价',
  review1_name: '橘猫妈妈',
  review1_content: '买了云朵系列，我家橘猫第一天就爱上了！质量超好，纸板很厚实，猫薄荷味道也很吸引它，强烈推荐！',
  review1_product: '云朵系列猫抓板',
  review2_name: '布偶铲屎官',
  review2_content: '原木猫抓柱做工精细，剑麻绳缠绕很紧实，底座稳得很，我家布偶猫每天都在上面磨爪子，沙发终于保住了！',
  review2_product: '原木猫抓柱',
  review3_name: '三花猫的主人',
  review3_content: '波浪猫抓板设计很聪明，可以翻面用，性价比极高。猫咪很喜欢趴在上面睡觉，一举两得！',
  review3_product: '波浪猫抓板',
  review4_name: '英短爸爸',
  review4_content: '包装很用心，产品质量没话说。客服响应也很快，有问题秒回。已经回购三次了，是我家猫咪的最爱品牌！',
  review4_product: '猫薄荷圆形猫抓板',

  // About Banner
  about_breadcrumb_home: '首页',
  about_breadcrumb_about: '关于我们',
  about_banner_title: '关于 Koorpet',
  about_banner_desc: '匠心品质，只为每一只猫咪的幸福生活。我们相信，好的产品能让人与宠物的关系更加美好。',

  // Company Stats
  stat1_num: '2024',
  stat1_label: '年创立',
  stat1_sub: '深耕宠物行业',
  stat2_num: '50+',
  stat2_label: '款产品',
  stat2_sub: '覆盖猫咪全场景需求',
  stat3_num: '10万+',
  stat3_label: '只猫咪',
  stat3_sub: '信赖 Koorpet 的选择',
  stat4_num: '30+',
  stat4_label: '项专利',
  stat4_sub: '持续创新研发实力',

  // Brand Story
  story_label: '品牌故事',
  story_float_num: '2024年',
  story_float_desc: '深耕猫抓板领域，专注品质与创新',
  story_title1: '从一块猫抓板',
  story_title2: '到一个品牌的诞生',
  story_p1: '2024年，Koorpet 正式成立，是国内专注猫抓板研发与生产的领先品牌。我们拥有4000平方米现代化工厂，配备全自动化生产线，年产能达200万件。',
  story_p2: '创始人凭借多年宠物用品行业经验，洞察到市场上缺乏真正注重品质和用户体验的猫抓板产品。于是决心创立 Koorpet，以更高的标准重新定义猫抓板。',
  story_p3: '从原材料筛选到成品出厂，每一道工序都经过严格把控。我们坚持"天然材料、匠心设计、严格品控"的理念，致力于为每一只猫咪提供最优质的抓挠体验。如今，Koorpet 已成为备受信赖的猫抓板品牌，产品远销多个国家和地区。',
  story_founder_name: 'John Yu',
  story_founder_role: 'Koorpet 创始人',
  story_founder_quote: '"我们不只是在做猫抓板，我们是在为每一个猫咪家庭创造更美好的共处空间。"',

  // Timeline
  timeline_label: '发展历程',
  timeline_title: '发展历程',
  timeline_desc: '从OEM代工到自有品牌，每一步都走得踏实。这是 Koorpet 成长的足迹。',
  milestone1_title: 'OEM业务起步',
  milestone1_desc: '开始为国际宠物品牌提供猫抓板OEM代工服务，建立供应链基础，积累生产技术和品控经验。',
  milestone2_title: '工厂扩建',
  milestone2_desc: '扩建4000平方米现代化工厂，引进全自动化生产线，年产能达500万件。',
  milestone3_title: '出口突破',
  milestone3_desc: 'OEM产品出口至10多个国家和地区，服务超过50家海外客户，品质获国际认可。',
  milestone4_title: '品牌筹备',
  milestone4_desc: '组建独立研发团队，筹备自有品牌 Koorpet，完成首批原创产品设计和专利布局。',
  milestone5_title: 'Koorpet 成立',
  milestone5_desc: 'Koorpet 品牌正式成立，首款高密度瓦楞纸猫抓板系列上市，获得市场热烈反响。',
  milestone6_title: '产品线扩展',
  milestone6_desc: '推出剑麻猫抓柱、猫爬架系列等新品，通过 ISO 9001 等国际认证，品牌影响力持续扩大。',
  milestone7_title: '用户里程碑',
  milestone7_desc: '累计服务超过10万只猫咪家庭，Koorpet 成为国内猫抓板品类领先品牌，持续领跑行业。',

  // Team Section
  team_label: '核心团队',
  team_title: '核心团队',
  team_desc: '一群真正爱猫的人，用专业与热情打造每一款产品',
  team_more: '以及',
  team_more2: '位充满热情的 Koorpet 专业团队成员',
  team1_name: 'John Yu',
  team1_role: '创始人',
  team1_desc: '曾在行业头部企业担任渠道负责人，深谙宠物用品市场。基于对猫咪福祉的深刻洞察和对产品品质的不懈追求，于2024年创立 Koorpet，带领团队从OEM代工到自有品牌，实现了从0到1的突破。',
  team1_tag1: '品牌创立',
  team1_tag2: '渠道拓展',
  team2_name: '林晓雯',
  team2_role: '首席设计师',
  team2_desc: '毕业于中央美术学院工业设计专业，深耕宠物产品设计8年，主导了 Koorpet 30余款产品的外观设计。',
  team2_tag1: '产品设计',
  team2_tag2: '用户体验',
  team3_name: '王建国',
  team3_role: '研发总监',
  team3_desc: '材料工程学博士，专注宠物用品材料研发10年，主导了 Koorpet 低粉尘配方和猫薄荷注入工艺的研发。',
  team3_tag1: '材料研发',
  team3_tag2: '工艺创新',
  team4_name: '张美玲',
  team4_role: '品质总监',
  team4_desc: '拥有ISO质量管理体系认证资质，负责 Koorpet 全线产品的品质把控，确保每一件产品都达到出厂标准。',
  team4_tag1: '品质管控',
  team4_tag2: 'ISO认证',

  // Certificates
  cert_label: '资质荣誉',
  cert_title: '资质荣誉',
  cert_desc: '多项权威认证与行业认可，是对 Koorpet 品质与创新的最好证明',
  cert1_title: 'ISO 9001',
  cert1_sub: '质量管理体系认证',
  cert1_desc: '通过国际质量管理体系认证，生产流程全程可追溯，品质有保障。',
  cert1_year: '2018年获得',
  cert2_title: '环保无毒认证',
  cert2_sub: '国家环保检测合格',
  cert2_desc: '所有原材料通过国家环保检测，无甲醛、无重金属，猫咪啃咬也安全。',
  cert2_year: '2017年获得',
  cert3_title: '宠物用品安全认证',
  cert3_sub: '中国宠物用品协会',
  cert3_desc: '获得中国宠物用品协会颁发的安全认证，是行业内少数获此认证的品牌之一。',
  cert3_year: '2019年获得',
  cert4_title: 'CE 欧盟认证',
  cert4_sub: '欧盟市场准入资质',
  cert4_desc: '通过欧盟CE认证，产品符合欧盟安全、健康、环保标准，可在欧盟市场销售。',
  cert4_year: '2020年获得',
  awards_title: '荣誉奖项',
  award1_title: '年度宠物用品创新设计奖',
  award1_org: '中国宠物产业博览会',
  award2_title: '最受铲屎官信赖品牌',
  award2_org: '宠物之家年度评选',
  award3_title: '国家高新技术企业认定',
  award3_org: '广东省科技厅',
  award4_title: '广东省著名商标',
  award4_org: '广东省工商行政管理局',
  award5_title: '宠物用品出口优质企业',
  award5_org: '广州市商务局',
  award6_title: '广州市优秀中小企业',
  award6_org: '广州市工业和信息化局',

  // About CTA
  about_cta_label: '加入我们',
  about_cta_title1: '一起为猫咪创造',
  about_cta_title2: '更美好的生活',
  about_cta_btn1: '探索产品',
  about_cta_btn2: '联系我们',

  // Products Banner
  products_breadcrumb_home: '首页',
  products_breadcrumb: '产品中心',
  products_banner_title: '产品中心',
  products_banner_desc: '精选天然材料，匠心打造每一款猫抓板，让猫咪爱上磨爪的仪式感',

  // Products CTA
  products_cta_title: '找不到合适的产品？',
  products_cta_desc: '联系我们，提供定制化解决方案，满足您的个性化需求',
  products_cta_btn: '联系我们',

  // Product Filter
  filter_all: '全部',
  filter_count: '共',
  filter_count2: '款产品',
  sort_default: '默认排序',
  sort_price_asc: '价格从低到高',
  sort_price_desc: '价格从高到低',
  category_corrugated: '瓦楞纸',
  category_sisal: '剑麻',
  category_combo: '综合',

  // Product Card
  product_view_detail: '查看详情',

  // Product Detail
  detail_product_code: '产品代码',
  detail_not_found: '找不到该产品',
  detail_back_to_products: '返回产品列表',

  // Tags
  tag_hot_selling: '热销中',
  tag_new: '新品',
  tag_corrugated_paper: '瓦楞纸',
  tag_limited_offer: '限时特惠',
  tag_bestseller: '爆款',
  tag_recommended: '推荐',
  tag_catnip: '猫薄荷',
  tag_sisal: '剑麻',
  tag_corner_protector: '护角',
  tag_cat_tree: '爬架',
  tag_eco_friendly: '环保',

  tag_double_sided: '双面可用',
  tag_sofa_protector: '护沙发',
  tag_multi_function: '多功能',

  detail_tab_desc: '产品详情',
  detail_tab_specs: '规格参数',
  detail_tab_faq: '常见问题',
  detail_spec_material: '材质',
  detail_spec_size: '尺寸',
  detail_spec_weight: '重量',
  detail_spec_moq: '最小起订量',
  detail_spec_suitable: '适用猫咪',
  detail_spec_suitable_val: '所有体型',
  detail_spec_package: '包装内容',
  detail_spec_package_val: '产品本体 × 1，说明书 × 1',

  detail_save: '省',
  detail_save_unit: '元',
  detail_btn_consult: '咨询购买',
  related_title: '你可能还喜欢',
  related_view_all: '查看全部',

  // Highlight titles
  highlight_title_triple_layer: '三层热压工艺',
  highlight_title_catnip_infused: '有机猫薄荷注入',
  highlight_title_eco_certified: '环保无毒认证',
  highlight_title_anti_slip: '防滑底部设计',
  highlight_title_natural_sisal: '天然剑麻绳',
  highlight_title_solid_wood: '实木底座',
  highlight_title_golden_height: '60cm黄金高度',
  highlight_title_nail_care: '自然修爪',
  highlight_title_double_sided: '双面可用',
  highlight_title_wave_curve: '波浪曲面设计',
  highlight_title_low_dust: '低粉尘配方',
  highlight_title_rubber_strip: '防滑橡胶条',
  highlight_title_sofa_design: '专为沙发设计',
  highlight_title_tool_free: '免工具安装',
  highlight_title_sofa_safe: '不损伤沙发',
  highlight_title_set_of_4: '一套4个',
  highlight_title_catnip_builtin: '有机猫薄荷内嵌',
  highlight_title_round_design: '圆形美观设计',
  highlight_title_safe_edge: '边缘安全处理',
  highlight_title_hot_seller: '热销爆款',
  highlight_title_three_level: '三层平台设计',
  highlight_title_15kg_capacity: '承重15kg+',
  highlight_title_hanging_toy: '悬挂玩具配件',
  highlight_title_wide_base: '宽大稳固底盘',
  // Highlight descriptions
  highlight_desc_triple_layer: '密度是普通产品2倍，更耐抓',
  highlight_desc_catnip_infused: '持久香气，猫咪主动靠近',
  highlight_desc_eco_certified: '啃咬也安全放心',
  highlight_desc_anti_slip: '使用时稳固不移位',
  highlight_desc_natural_sisal: '手工缠绕，粗细均匀韧性足',
  highlight_desc_solid_wood: '松木防腐处理，稳固不倒',
  highlight_desc_golden_height: '满足猫咪站立伸展需求',
  highlight_desc_nail_care: '有效修剪猫爪，保护家具',
  highlight_desc_double_sided: '翻转继续使用，寿命翻倍',
  highlight_desc_wave_curve: '契合猫咪自然抓挠姿势',
  highlight_desc_low_dust: '纸屑少，保持家居整洁',
  highlight_desc_rubber_strip: '使用时稳固不移位',
  highlight_desc_sofa_design: '完美贴合沙发角，全方位保护',
  highlight_desc_tool_free: '强力魔术贴，30秒搞定',
  highlight_desc_sofa_safe: '背面保护层，不留痕迹',
  highlight_desc_set_of_4: '同时保护沙发四个角',
  highlight_desc_catnip_builtin: '解决猫咪不爱用抓板难题',
  highlight_desc_round_design: '可平放可挂墙，一物两用',
  highlight_desc_safe_edge: '无毛刺，猫咪使用安全',
  highlight_desc_hot_seller: '月销超5000件，好评如潮',
  highlight_desc_three_level: '满足猫咪喜欢高处的天性',
  highlight_desc_15kg_capacity: '多猫家庭也能放心使用',
  highlight_desc_hanging_toy: '激发猫咪玩耍兴趣',
  highlight_desc_wide_base: '跳跃也不倾倒',

  // Contact Banner
  contact_breadcrumb_home: '首页',
  contact_breadcrumb: '联系我们',
  contact_banner_title: '联系我们',
  contact_banner_desc: '无论是产品咨询、合作洽谈还是售后服务，我们随时准备为您提供帮助',

  // Contact Form
  contact_form_label: '发送消息',
  contact_form_title: '给我们留言',
  contact_form_desc: '填写下方表单，我们将在1个工作日内回复您',
  contact_form_success_title: '留言已发送！',
  contact_form_success_desc: '感谢您的留言，我们将在1个工作日内与您联系。',
  contact_form_success_btn: '再次留言',
  contact_form_name: '您的姓名',
  contact_form_name_placeholder: '请输入您的姓名',
  contact_form_phone: '联系电话',
  contact_form_phone_placeholder: '请输入您的手机号',
  contact_form_email: '电子邮箱',
  contact_form_email_placeholder: '请输入您的邮箱地址',
  contact_form_inquiry: '咨询类型',
  contact_form_company: '公司名称',
  contact_form_company_optional: '（选填）',
  contact_form_company_placeholder: '如有合作需求请填写公司名称',
  contact_form_message: '留言内容',
  contact_form_message_placeholder: '请详细描述您的需求或问题，我们将尽快为您解答...',
  contact_form_required: '*',
  contact_form_error: '发送失败，请稍后重试或直接拨打客服热线',
  contact_form_sending: '发送中...',
  contact_form_submit: '发送留言',
  inquiry_type1: '产品咨询',
  inquiry_type2: '批发合作',
  inquiry_type3: '售后服务',
  inquiry_type4: '媒体合作',
  inquiry_type5: '其他问题',

  // Contact CTA
  contact_cta_title: '还有其他问题？',
  contact_cta_desc: '查看我们的常见问题解答，或直接发送邮件至',
  contact_cta_btn_browse: '浏览产品',
  contact_cta_btn_email: '发送邮件',

  // Contact Info
  contact_info1_title: '公司地址',
  contact_info1_line1: 'FLAT /RM A 9/F SILVERCORP',
  contact_info1_line2: 'INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  contact_info1_action: '查看地图',
  contact_info2_title: '客服热线',
  contact_info2_line1: '客服热线',
  contact_info2_line2: '周一至周五 9:00 - 18:00',
  contact_info2_action: '在线咨询',
  contact_info3_title: '电子邮件',
  contact_info3_line1: 'cs@koorpet.com',
  contact_info3_line2: '商务合作：cs@koorpet.com',
  contact_info3_action: '发送邮件',
  contact_info4_title: 'WhatsApp',
  contact_info4_line1: 'Koorpet 官方',
  contact_info4_line2: '通过 WhatsApp 与我们直接沟通',
  contact_info4_action: '发起对话',

  // Footer
  footer_brand_desc: '专注猫抓板研发与生产，让每一只猫咪都有属于自己的快乐领地。',
  footer_nav_title: '快速导航',
  footer_products_title: '产品系列',
  footer_product1: '瓦楞纸猫抓板',
  footer_product2: '剑麻猫抓柱',
  footer_product3: '猫爬架系列',
  footer_product4: '护角系列',
  footer_product5: '猫薄荷系列',
  footer_contact_title: '联系我们',
  footer_address: 'FLAT /RM A 9/F SILVERCORP INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  footer_phone: '周一至周五 9:00 - 18:00',
  footer_whatsapp: 'WhatsApp 在线客服',
  footer_email: 'cs@koorpet.com',
  footer_hours: '周一至周五 9:00 - 18:00',
  footer_copyright: '© 2026 DANA INTERNATIONAL (HK) CO., LIMITED',
  footer_privacy: '隐私政策',
  footer_terms: '使用条款',
  footer_admin: '管理后台',

  // Legal Page
  legal_breadcrumb: '法律条款',
  legal_banner_title: '法律条款',
  legal_banner_desc: '请仔细阅读以下条款，了解我们如何保护您的权益',
  legal_updated: '最后更新',

  // Privacy Policy
  privacy_s1_title: '关于本政策',
  privacy_s1_p1: 'DANA INTERNATIONAL (HK) CO., LIMITED（以下简称"Koorpet"或"我们"）非常重视用户的隐私保护。本隐私政策说明了我们如何收集、使用、存储和保护您的个人信息。',
  privacy_s1_p2: '当您使用我们的网站、产品或服务时，即表示您同意本隐私政策的条款。如您不同意，请停止使用我们的服务。',
  privacy_s2_title: '我们收集的信息',
  privacy_s2_p1: '为了提供更好的服务，我们可能收集以下类型的信息：',
  privacy_s2_li1: '身份信息：姓名、联系电话、电子邮箱地址',
  privacy_s2_li2: '交易信息：订单记录、收货地址、支付信息',
  privacy_s2_li3: '设备信息：IP地址、浏览器类型、操作系统',
  privacy_s2_li4: '使用数据：页面访问记录、点击行为、搜索关键词',
  privacy_s3_title: '信息的使用方式',
  privacy_s3_p1: '我们收集的信息将用于以下目的：',
  privacy_s3_li1: '处理您的订单并提供相关售后服务',
  privacy_s3_li2: '向您发送产品更新、促销活动等通知（您可随时退订）',
  privacy_s3_li3: '改善我们的网站功能和用户体验',
  privacy_s4_title: '信息共享与披露',
  privacy_s4_p1: '我们不会将您的个人信息出售给第三方。在以下情况下，我们可能会共享您的信息：',
  privacy_s4_p2: '与物流合作伙伴共享配送信息；配合法律法规要求；经您明确授权的情况。',
  privacy_s5_title: '信息安全',
  privacy_s5_p1: '我们采用行业标准的安全措施保护您的个人信息，包括SSL加密传输、数据访问控制等。但请注意，互联网传输并非绝对安全，我们无法保证信息传输的绝对安全性。',
  privacy_s6_title: '您的权利',
  privacy_s6_p1: '您对自己的个人信息享有以下权利：',
  privacy_s6_li1: '查阅权：您可以随时查阅我们持有的您的个人信息',
  privacy_s6_li2: '更正权：如信息有误，您可以要求我们更正',
  privacy_s6_li3: '删除权：在特定情况下，您可以要求我们删除您的个人信息',
  privacy_s7_title: '联系我们',
  privacy_s7_p1: '如您对本隐私政策有任何疑问，请通过以下方式联系我们：',

  // Terms of Use
  terms_s1_title: '接受条款',
  terms_s1_p1: '欢迎使用 Koorpet 官方网站。访问或使用本网站，即表示您同意受本使用条款的约束。',
  terms_s1_p2: '我们保留随时修改本条款的权利。修改后的条款将在网站上公布，继续使用本网站即视为接受修改后的条款。',
  terms_s2_title: '产品与购买',
  terms_s2_p1: '通过本网站购买产品时，您需遵守以下规定：',
  terms_s2_li1: '您提供的所有信息必须真实、准确、完整',
  terms_s2_li2: '您必须年满18周岁或在监护人同意下使用本服务',
  terms_s2_li3: '产品价格可能随时变动，以下单时显示的价格为准',
  terms_s3_title: '配送与交付',
  terms_s3_p1: '我们将尽力按照承诺的时间配送产品，但实际配送时间可能因物流情况而有所不同。',
  terms_s3_p2: '配送范围、运费及预计到达时间以结算页面显示为准。如遇不可抗力因素导致延误，我们将及时通知您。',
  terms_s4_title: '退换货政策',
  terms_s4_p1: '我们承诺提供优质的售后服务，退换货政策如下：',
  terms_s4_li1: '收到商品后7天内，如产品存在质量问题，可申请退换货',
  terms_s4_li2: '产品须保持原包装完好，未经使用或损坏',
  terms_s4_li3: '退货运费由责任方承担；如属质量问题，运费由我们承担',
  terms_s5_title: '知识产权',
  terms_s5_p1: '本网站所有内容，包括但不限于文字、图片、Logo、产品设计等，均受知识产权法律保护，归 Koorpet 所有。',
  terms_s5_p2: '未经我们书面许可，您不得复制、修改、分发或以任何方式使用本网站的任何内容。',
  terms_s6_title: '免责声明',
  terms_s6_p1: '本网站内容仅供参考。我们不对因使用本网站或依赖本网站信息而产生的任何直接或间接损失承担责任。产品图片仅供参考，实际产品以收到的实物为准。',
  terms_s7_title: '适用法律',
  terms_s7_p1: '本使用条款受中华人民共和国法律管辖。如发生争议，双方应首先协商解决；协商不成的，提交香港特别行政区有管辖权的法院诉讼解决。',
  terms_s8_title: '联系我们',
  terms_s8_p1: '如您对本使用条款有任何疑问，请通过以下方式联系我们：',
};

export default zh;
